import React, { useState } from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean, RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  PickTicketBean,
  PickTicketSearchCriteria,
  RestCustomerListRequest,
  RestPageListBean,
  RestPickTicketListRequest,
  RestPickTicket_v1Request,
  RestPrintInputRequest,
  RestReadRequest,
  RestSalesOrderRequest,
  SalesOrderSearchCriteria,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DatePickerComponent,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { PickTicketLookupHandler } from "../lookup/PickTicketLookupHandler.js";
import { SalesOrderLookupHandler } from "../lookup/SalesOrderLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { PickTicketService } from "../services/PickTicketService.js";
import { ReportService } from "../services/ReportService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import {
  PopupCustomerModule,
  PopupPickTicketModule,
  PopupSalesModule,
} from "./ModuleUtil.js";
import { ModuleUtils } from "./ModuleUtils.js";
class GenerateInvoice extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.customerCodeRef = React.createRef();
    this.state = {
      pageTitle: "Generate Invoice",
      isShowExitButton: true,
      isShowExecuteButton: true,
      isShowResetButton: true,
      isShowClearCriteriaButton: true,
      criteria: new PickTicketSearchCriteria(),
      pagelist: new PageListBean(),
      ispickTicketDataFound: false,
      pickTicketDataList: [],
      companyCode: "",
      error_List: [],
      success_List: [],
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesOrderList: true,
      showAutoCompleteCustomerList: true,
      pickTicketListFCustomerList: true,
      salesOrderListForAutoCompleteList: new Array(),
      showAutoCompleteorAutoCompleteList: new Array(),
      showAutoCompletePickTicketList: true,
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      moduleForPopup: [],
      isShowCustomerModule: false,
      isShowSalesModule: false,
      isShowPickticketModule: false,
      pickTicketData: new PickTicketBean(),
      order: "asc",
      customerLookupHandler: null,
      salesOrderLookupHandler: null,
      pickTicketLookupHandler: null,
      isDisableFields: false,
      isShowCustomerLookup: true,
      isShowSalesOrderLookup: true,
      isShowPickTicketLookup: true,
      sortField: "",
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    ModuleUtils.getPickTicketStatusList();
    this.initLookuphandlers();
  }
  initLookuphandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
    let salesOrderLookupHandler = new SalesOrderLookupHandler(
      this.companyCode,
      "SalesOrderNumber"
    );
    this.setState({
      salesOrderLookupHandler: salesOrderLookupHandler,
    });
    let pickTicketLookupHandler = new PickTicketLookupHandler(
      this.companyCode,
      "PickTicket"
    );
    this.setState({
      pickTicketLookupHandler: pickTicketLookupHandler,
    });
  };
  showErrorMessage = (response) => {
    if (response.error != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_List: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let infoList = this.state.success_List;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          infoList.push(info.messageDescription)
        )
      );
      this.setState({ success_List: infoList });
      this.setState({
        alertMessage: infoList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  readPickTicket = (list) => {
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = list.code;
    PickTicketService.readPickTicket(
      request,
      this.readPickTicketResponse,
      this.errorCallBack
    );
  };
  readPickTicketResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.pickTicket != null) {
      let pickTicket = response.data.pickTicket;
      this.savePickTicket(pickTicket);
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  generateInvoice = (e, list) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Generate Invoice..",
      });
      this.readPickTicket(list);
    }
  };
  savePickTicket = (pickTicket) => {
    let request = new RestPickTicket_v1Request();
    request.companyCode = this.companyCode;
    request.code = pickTicket.code;
    request.pickTicketBean = pickTicket;
    request.isLockRequired = true;
    if (SecurityAccessManager.MassGenarateInvoices_IsAccessible()) {
      PickTicketService.updatePickTicketAndCreateInvoice(
        request,
        this.generateInvoiceResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  generateInvoiceResponse = (response) => {
    let success = this.handleInvoiceResponse(response.data);
    if (success) {
      if (
        response.data != null &&
        response.data.invoiceResponse != null &&
        response.data.invoiceResponse.invoice != null
      ) {
        let invoice = response.data.invoiceResponse.invoice;
        this.generateReport(invoice.code);
      }
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  generateReport = (code) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = 1;
    let requestInput = new RestPrintInputRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.code = code;
    requestInput.report = reportBean;
    if (SecurityAccessManager.MassGenarateInvoices_IsAccessible()) {
      ReportService.generateInvoicePrintReport(
        requestInput,
        this.generateReportResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  generateReportResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  handleInvoiceResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.mainOperationResponse)) {
      if (!isEmptyArray(response.mainOperationResponse.errors)) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = "Unable to Generate Invoice"), errList.push(errMsg)
          )
        );
        success = false;
      }
      if (!isEmptyArray(response.mainOperationResponse.infos)) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );
        success = true;
      }
    }
    if (!isEmpty(response.invoiceResponse)) {
      if (!isEmptyArray(response.invoiceResponse.errors)) {
        response.invoiceResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        success = false;
      }
      if (!isEmptyArray(response.invoiceResponse.infos)) {
        response.invoiceResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );
        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
      let successMsg = [];
      successMsg.push(msg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(infoMsg)) {
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(errMsg)) {
      let errorMsg = [];
      errorMsg.push(errMsg);
      this.setState({
        alertMessage: errorMsg,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({ error_list: errList });
    return success;
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  clearCriteria = () => {
    let criteria = new PickTicketSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = "";
    criteria.customerName = "";
    criteria.pickTicketCode = "";
    criteria.salesOrderNumber = "";
    this.setState({ criteria: criteria });
  };
  reset = () => {
    let criteria = new PickTicketSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = "";
    criteria.customerName = "";
    criteria.pickTicketCode = "";
    criteria.salesOrderNumber = "";
    this.setState({
      criteria: criteria,
      ispickTicketDataFound: false,
      pickTicketDataList: new Array(),
      isDisableFields: false,
      isShowCustomerLookup: true,
      isShowSalesOrderLookup: true,
      isShowPickTicketLookup: true,
      isShowClearCriteriaButton: true,
    });
    this.hideAlertCallBack();
  };
  execute = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing..",
    });
    this.loadpage(1);
    this.hideAlertCallBack();
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadpage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.status = LogicConstants.PICK_TICKET_PICKED_STATUS;
    let pageInput = new PageListBean();
    pageInput.currentPage = pageNumber;
    let listrequest = new RestPickTicketListRequest();
    listrequest.searchCriteria = criteria;
    listrequest.pageInput = pageInput;
    this.loadPickTicketDetail(listrequest);
  };
  loadPickTicketDetail = (listrequest) => {
    if (SecurityAccessManager.MassGenarateInvoices_IsAccessible()) {
      PickTicketService.getPickTickets(
        listrequest,
        this.loadPickTicketsResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadPickTicketsResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.pickTicketPageList != null) {
      let pickTicketInvoiceDataList = new Array();
      if (!isEmptyArray(response.data.pickTicketPageList.pickTickets)) {
        let pickTicketPageList = response.data.pickTicketPageList.pickTickets;
        pickTicketPageList.map((pickTicket) => {
          if (pickTicket.isPackedFlag) {
            pickTicketInvoiceDataList.push(pickTicket);
          }
        });
      }
      this.setState({
        ispickTicketDataFound: true,
        pickTicketDataList: pickTicketInvoiceDataList,
        isShowClearCriteriaButton: false,
        isDisableFields: true,
        isShowCustomerLookup: false,
        isShowSalesOrderLookup: false,
        isShowPickTicketLookup: false,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error: " + error);
  };
  viewCustomerCode = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalexit}
            />
          ),
        });
      }
    }
  };
  viewSalesOrderCode = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalexit}
            />
          ),
        });
      }
    }
  };
  viewPickTicketCode = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPickticketModule: true,
          moduleForPopup: (
            <PopupPickTicketModule
              pickTicketCode={code}
              onModuleExit={this.onPopupModalexit}
            />
          ),
        });
      }
    }
  };
  onPopupModalexit = () => {
    this.closeModalCallBack(false);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowAlert: isDisplayed,
      error_List: [],
    });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowSalesModule: isOpen,
      isShowPickticketModule: isOpen,
      moduleForPopup: [],
    });
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList == true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ critera: tempCriteria });
  };
  readandsetCustomterDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomterDetailResponse,
      this.errorCallBack
    );
  };
  readandsetCustomterDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readCustomerBySearchString = (searchString) => {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let customer_pagelist = new RestPageListBean();
    customer_pagelist.pageSize = 100;
    let customer_requestInput = new RestCustomerListRequest();
    customer_requestInput.pageInput = customer_pagelist;
    customer_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      customer_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  };
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomterDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  salesOrderOnChange = (e) => {
    let salesOrderNumber = e.target.value;
    this.state.showAutoCompleteSalesOrderList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesOrderList;
    if (isEmpty(salesOrderNumber)) {
      this.state.showAutoCompleteSalesOrderList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesOrderList;
      let criteria = this.state.criteria;
      criteria.salesOrderNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteSalesOrderList: showAutoCompleteList,
        criteria: criteria,
        salesOrderListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "salesOrderNumber" &&
      showAutoCompleteList === true &&
      salesOrderNumber !== ""
    ) {
      this.readSalesOrderBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetSalesOrderDetail = (salesOrderNumber) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = salesOrderNumber;
    input.isLoadChildren = true;
    SalesOrderService.readSalesOrder(
      input,
      this.readandsetSalesOrderDetailResponse,
      this.errorCallBack
    );
  };
  readandsetSalesOrderDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.salesOrder != null) {
      let salesOrderData = response.data.salesOrder;
      if (!isEmpty(salesOrderData)) {
        criteria.salesOrderNumber = salesOrderData.code;
        this.setState({
          criteria: criteria,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readSalesOrderBySearchString(searchString) {
    let searchCriteria = new SalesOrderSearchCriteria();
    searchCriteria.companycode = this.companyCode;
    searchCriteria.salesOrderNumberStartsWith = searchString;
    searchCriteria.salesOrderNumberContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestSalesOrderRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    SalesOrderService.getSalesOrderPageList(
      input,
      this.readBySalesOrderCodeResponse,
      this.errorCallBack
    );
  }
  readBySalesOrderCodeResponse = (response) => {
    let salesOrderNumberData = response.data.salesOrderPageList.salesOrders;
    let simpleAutoCompleteList = new Array();
    if (salesOrderNumberData.length > 0 && salesOrderNumberData != null) {
      salesOrderNumberData.map((salesOrderNumber) => {
        let simpleItemBean = {
          code: salesOrderNumber.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      salesOrderListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  salesOrderEnterKeyEventHandler = (e) => {
    let salesOrderNumber = e.target.value;
    this.readandsetSalesOrderDetail(salesOrderNumber);
    this.setState({
      salesOrderListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading ...",
    });
  };
  displayAutoCompleteSalesOrderList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteSalesOrderList: showAutoCompleteList,
    });
  };
  pickTicketOnChange = (e) => {
    let pickTicketCode = e.target.value;
    this.state.showAutoCompletePickTicketList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompletePickTicketList;
    if (isEmpty(pickTicketCode)) {
      this.state.showAutoCompletePickTicketList = false;
      let showAutoCompleteList = this.state.showAutoCompletePickTicketList;
      let criteria = this.state.criteria;
      criteria.pickTicketCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompletePickTicketList: showAutoCompleteList,
        criteria: criteria,
        pickTicketListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "pickTicketCode" &&
      showAutoCompleteList === true &&
      pickTicketCode !== ""
    ) {
      this.readPickTicketBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetPickTicketDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.pickTicket != null) {
      let pickTicketData = response.data.pickTicket;
      if (!isEmpty(pickTicketData)) {
        criteria.pickTicketCode = pickTicketData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetPickTicketDetail = (pickTicketCode) => {
    let listrequest = new RestReadRequest();
    listrequest.companyCode = this.companyCode;
    listrequest.code = pickTicketCode;
    listrequest.isLoadChildren = true;
    PickTicketService.readPickTicket(
      listrequest,
      this.readandsetPickTicketDetailResponse,
      this.errorCallBack
    );
  };
  readPickTicketBySearchString(searchString) {
    let searchCriteria = new PickTicketSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.pickTicketStartsWith = searchString;
    searchCriteria.pickTicketContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestPickTicketListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    PickTicketService.getPickTicketPageList(
      input,
      this.readByPickTicketCodeResponse,
      this.errorCallBack
    );
  }
  readByPickTicketCodeResponse = (response) => {
    let pickTicketCodeData = response.data.pickTicketPageList.pickTickets;
    let simpleAutoCompleteList = new Array();
    if (pickTicketCodeData.length > 0 && pickTicketCodeData != null) {
      pickTicketCodeData.map((pickTicketCode) => {
        let simpleItemBean = {
          code: pickTicketCode.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      pickTicketListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  pickTicketEnterKeyEventHandler = (e) => {
    let pickTicketCode = e.target.value;
    this.readandsetPickTicketDetail(pickTicketCode);
    this.setState({
      pickTicketListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompletePickTicketList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePickTicketList: showAutoCompleteList });
  };
  handleSortingchange = (e, accessor) => {
    if (e.detail == 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let pickTicketDataList = this.state.pickTicketDataList;
    if (sortField && !isEmptyArray(pickTicketDataList)) {
      const sorted = [...pickTicketDataList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ pickTicketDataList: sorted });
    }
  };
  render() {
    let pickTicketDataList = this.state.pickTicketDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          hideAlertCallBack={this.hideAlertCallBack}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          clearCriteria={this.clearCriteria}
          reset={this.reset}
          execute={this.execute}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          salesOrderOnChange={this.salesOrderOnChange}
          salesOrderEnterKeyEventHandler={this.salesOrderEnterKeyEventHandler}
          displayAutoCompleteSalesOrderList={
            this.displayAutoCompleteSalesOrderList
          }
          pickTicketOnChange={this.pickTicketOnChange}
          pickTicketEnterKeyEventHandler={this.pickTicketEnterKeyEventHandler}
          displayAutoCompletePickTicketList={
            this.displayAutoCompletePickTicketList
          }
        />
        {this.state.ispickTicketDataFound && (
          <>
            <Row>
              <FormLabel className="table_title">Invoice List</FormLabel>
            </Row>
            <div className="div_default">
              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th
                      onClick={(e) =>
                        this.handleSortingchange(e, "customerCode")
                      }
                    >
                      Customer
                      {this.state.order === "desc" &&
                      this.state.sortField === "customerCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingchange(e, "customerName")
                      }
                    >
                      CustomerName
                      {this.state.order === "desc" &&
                      this.state.sortField === "customerName" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingchange(e, "salesOrderNumber")
                      }
                    >
                      SalesOrder
                      {this.state.order === "desc" &&
                      this.state.sortField === "salesOrderNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th onClick={(e) => this.handleSortingchange(e, "code")}>
                      PickTicket #{" "}
                      {this.state.order === "desc" &&
                      this.state.sortField === "code" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th onClick={(e) => this.handleSortingchange(e, "status")}>
                      Status
                      {this.state.order === "desc" &&
                      this.state.sortField === "status" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingchange(e, "createdDate")
                      }
                    >
                      Created Date
                      {this.state.order === "desc" &&
                      this.state.sortField === "createdDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {pickTicketDataList.map((data, index) => (
                    <tr key={index}>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewCustomerCode(e, data.customerCode)
                          }
                        >
                          {data.customerCode}
                        </Button>
                      </td>
                      <td>{data.customerName}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewSalesOrderCode(e, data.salesOrderNumber)
                          }
                        >
                          {data.salesOrderNumber}
                        </Button>
                      </td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) => this.viewPickTicketCode(e, data.code)}
                        >
                          {data.code}
                        </Button>
                      </td>
                      <td>
                        {ModuleUtils.getPickTicketStatusCaption(data.status)}
                      </td>
                      <td>{data.createdDate}</td>
                      <td>
                        <Button
                          id="fabric_Add_Button"
                          onClick={(e) => this.generateInvoice(e, data)}
                        >
                          Generate Invoice
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {pickTicketDataList.length != 0 ? null : (
                <div className="no_Data">{"No Data"}</div>
              )}
            </div>
          </>
        )}
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowCustomerModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel10"}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowSalesModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel10"}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowPickticketModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel10"}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const onChange = (e) => props.onChange(e);
  const customerCodeRef = props.customerCodeRef;
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  let salesOrderRef = React.createRef();
  const salesOrderOnChange = (e) => {
    props.salesOrderOnChange(e);
  };
  const salesOrderEnterKeyEventHandler = (e) => {
    props.salesOrderEnterKeyEventHandler(e);
  };
  const displayAutoCompleteSalesOrderList = () => {
    props.displayAutoCompleteSalesOrderList();
  };
  let pickTicketRef = React.createRef();
  const pickTicketOnChange = (e) => {
    props.pickTicketOnChange(e);
  };
  const pickTicketEnterKeyEventHandler = (e) => {
    props.pickTicketEnterKeyEventHandler(e);
  };
  const displayAutoCompletePickTicketList = () => {
    props.displayAutoCompletePickTicketList();
  };
  let criteria = props.criteria;
  let customerLookupHandler = props.customerLookupHandler;
  let salesOrderLookupHandler = props.salesOrderLookupHandler;
  let pickTicketLookupHandler = props.pickTicketLookupHandler;
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            onChange={customerCodeOnChange}
            value={criteria.customerCode}
            lookupRequired={props.isShowCustomerLookup}
            showCriteriaDialog={true}
            lookupHandler={customerLookupHandler}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            displayAutoCompleteList={displayAutoCompleteList}
            enableAutoCompleteTextBox={true}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="customerName"
            value={criteria.customerName}
            onChange={onChange}
            disabled={true}
          />
        </Col>
        <FormLabel>FromDate</FormLabel>
        <Col sm="2">
          <DatePickerComponent
            name="pickTicketFromCreatedDate"
            value={criteria.pickTicketFromCreatedDate}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="0">
          <FormLabel>To Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent
            name="pickTicketToCreatedDate"
            value={criteria.pickTicketToCreatedDate}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
      </Row>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          <FormLabel sm="1">PickTicket Number</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={pickTicketRef}
            name="pickTicketCode"
            value={criteria.pickTicketCode}
            onChange={pickTicketOnChange}
            lookupRequired={props.isShowPickTicketLookup}
            showCriteriaDialog={true}
            lookupHandler={pickTicketLookupHandler}
            enterKeyEventHandler={pickTicketEnterKeyEventHandler}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompletePickTicketList}
            autoCompleteListData={props.pickTicketListForAutoCompleteList}
            showAutoCompleteList={props.showAutoCompletePickTicketList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>SalesOrder Number</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={salesOrderRef}
            name="salesOrderNumber"
            value={criteria.salesOrderNumber}
            onChange={salesOrderOnChange}
            lookupRequired={props.isShowSalesOrderLookup}
            showCriteriaDialog={true}
            lookupHandler={salesOrderLookupHandler}
            enterKeyEventHandler={salesOrderEnterKeyEventHandler}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteSalesOrderList}
            autoCompleteListData={props.salesOrderListForAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteSalesOrderList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
      </Row>
    </div>
  );
}
function GenerateInvoiceModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <GenerateInvoice {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default GenerateInvoiceModule;
